import defaultProperties from '@/service/entity/default-properties.js';

const flowReference = (diagram, reference) => {
    // flows not attached to a diagram node will not have a cell reference
    if (reference === undefined) {
        return {type: 'dangling', object: 'unidentified'};
    }

    for (const cell of diagram.cells) {
        if (cell.id === reference) {
            return {type: cell.data.type, object: reference};
        }
    }

    return {type: 'unknown', object: 'unidentified'};
};

const convert = (model) => {
    const dataFlows = [];

    // there may be no diagrams, or no cells within a diagram
    model.detail.diagrams?.forEach((diagram) => {
        diagram.cells?.forEach((cell) => {
            if (cell.data.type === 'tm.Flow') {
                dataFlows.push({
                    symbolic_name: cell.id,
                    title: cell.data.name || 'Data flow generated by export from Threat Dragon',
                    description: cell.data.description,
                    source: flowReference(diagram, cell.source.cell),
                    destination: flowReference(diagram, cell.target.cell),
                    has_sensitive_data: true,
                    encrypted: cell.data.isEncrypted
                });
            }
        });
    });

    return dataFlows;
};

const merge = (model) => {
    const flows = [];
    let zIndex = 0;

    if (model.data_flows) {
        for (const dataFlow of model.data_flows) {
            const flow = defaultProperties.defaultEntity('tm.Flow');
            flow.data.name = flow.labels[0].attrs.labelText.text = dataFlow.title;
            flow.data.description = dataFlow.description;
            flow.data.isEncrypted = dataFlow.encrypted;
            flow.id = dataFlow.symbolic_name;
            flow.zIndex = zIndex++;
            flow.source.cell = dataFlow.source.object;
            flow.target.cell = dataFlow.destination.object;
            flows.push(flow);
        }
    }

    return flows;
};

export default {
    convert,
    merge
};
